import { createSurveyStyles } from '@sm/webassets';
import { Theme } from '~app/sharedTypes';

const useStyles = createSurveyStyles((surveyTheme: Theme) => ({
  privacyComponentContainer: {
    paddingTop: 80,
    margin: '0 auto',
    textAlign: 'center',
  },
}));

export default useStyles;
